import axiosRetry from "axios-retry";
import { API_RETRY_COUNT, API_RETRY_DELAY, RETRY_CODES, RETRY_STATUS_CODES } from "./Constants";
import axios from "axios";

var axiosCached = null;

function axiosWithRetry(retry_count = 3) {
  if (axiosCached !== null) {
    return axiosCached;
  }

  axiosRetry(axios, {
    retries: API_RETRY_COUNT,
    shouldResetTimeout: true, // Use timeout per call not all retry calls.
    retryDelay: (retryCount) => {
      return retryCount * API_RETRY_DELAY; // time interval between retries
    },
    retryCondition: (error) => {
      // if retry condition is not specified, by default idempotent requests are retried
      return RETRY_CODES.includes(error.code, 0) || RETRY_STATUS_CODES.includes(error.response?.status, 0); //&& error.code !== "ERR_CANCEL";
    },
  });
  axiosCached = axios;
  return axiosCached;
}

export default axiosWithRetry;
